/* cdn_url.js - convert URLs to CDN, if possible */

/* Copyright (c) 2022 Tikkl Inc. */

/*
modification history
--------------------
01b,30aug22,mno  named exports.
01a,17aug22,mno  created. 
*/

const CDN_MAP = [
  [ 'https://s3.us-west-2.amazonaws.com/com.tikkl.corp/', 'https://cdn.tikkl.com/' ],
  [ 'https://com.tikkl.corp.s3.us-west-2.amazonaws.com/', 'https://cdn.tikkl.com/'],
];

const IMG_SIZE_MAP = {
  thumbnail: 'thumbnail',  // w: 100px
  icon64:    'thumbnail',  
  small:     'small',      // w: 400px
  medium:    'medium',
  large:     'medium',     // w: 800px
  max:       'large',      // w: 1600px
  auto:      'large',
}
const IMG_SIZE_KEYS = Object.keys(IMG_SIZE_MAP);

const translateToCdnPath = (path) => {
  const [ src, target ] = CDN_MAP.find((m) => path.indexOf(m[0]) === 0) || [];

  if (target){
    return path.replace(src, target);
  }

  return path;
}

const cdnUrl = (path, size='medium') => {
  const cdnPath = translateToCdnPath(path);

  if (
    cdnPath.includes('/images/origin/')
    && IMG_SIZE_KEYS.includes(size)
  ){
    return cdnPath.replace('/origin/', `/${IMG_SIZE_MAP[size]}/`);
  }  

  return cdnPath;
};

export default cdnUrl;